import { render, staticRenderFns } from "./ModalConduct.vue?vue&type=template&id=485192be&scoped=true&"
import script from "./ModalConduct.vue?vue&type=script&lang=js&"
export * from "./ModalConduct.vue?vue&type=script&lang=js&"
import style0 from "./ModalConduct.vue?vue&type=style&index=0&id=485192be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485192be",
  null
  
)

component.options.__file = "ModalConduct.vue"
export default component.exports